import { useQuery } from "@tanstack/vue-query";
import { computed, type MaybeRef, unref } from "vue";
import todosService from "@/services/todos";
import type { GetTodosParams, UseTodosOptions, UseTodosReturn } from "../types.ts";

export const useTodos = (params: MaybeRef<GetTodosParams>, options: UseTodosOptions = {}): UseTodosReturn => {
  const unrefParams = computed(() => unref(params));
  const queryKey = computed(() => [
    "todos",
    unrefParams.value.limit,
    unrefParams.value.page,
    unrefParams.value.q,
    unrefParams.value.status,
    unrefParams.value.title,
  ]);

  const {
    data: todos,
    isLoading: todosIsLoading,
    error: todosError,
  } = useQuery({
    queryKey: queryKey.value,
    queryFn: async () => {
      const response = await todosService.getTodos(unrefParams.value);
      return response?.data?.items ?? [];
    },
    enabled: options.enabled,
  });

  return {
    todos,
    todosIsLoading,
    todosError,
  };
};
